// Отладочный вывод: только в режиме разработки. В рабочей сборке не пишет ничего (console.warn и console.error остаются для диагностики).
export const debug: (...args: unknown[]) => void = import.meta.env.DEV ? (...args) => console.log(...args) : () => undefined;
